import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import PlaceholderReportScreen from './PlaceholderReportScreen';

const MealPlanRevenueReportScreen: React.FC = () => (
  <PlaceholderReportScreen
    title="Meal Plan Revenue"
    description="Revenue by meal plan and the impact of upgrades / downgrades."
    icon={<IconSystem.tag size={18} />}
    phaseLabel="Coming in Phase 3"
    comingSoonHint="Bookings × covers × meal plan; net upgrade/downgrade revenue per plan."
  />
);
export default MealPlanRevenueReportScreen;
